// import sharedMutations from 'vuex-shared-mutations';

export const categoryModule = {

    state() {
        return {
            categories: [],
            category: null,
            products: [],
            pagination: null,
        }
    },

    getters: {
        categories(state) {
            return state.categories;
        },
        category(state) {
            return state.category;
        },
        products(state) {
            return state.products
        },
        pagination(state) {
            return state.meta
        },
    },

    mutations: {
        setCategories(state, data) {
            state.categories = data
        },
        setCategory(state, data) {
            state.category = data
        },
        setProducts(state, data) {
            state.products = data
        },
        setPagination(state, data) {
            state.meta = data
        },
    },

    actions: {
        async getCategories({ commit }) {
            await axios.get('/api/categories').then((res) => {
                commit('setCategories', res.data.data)
            }).catch((err) => {

            })
        },
        async getCategory({ commit }, data) {
            await axios.get('/api/category/' + data.slug).then((res) => {
                commit('setCategory', res.data.data)
            }).catch((err) => {

            })
        },
        async getCategoryProducts({ commit }, data) {
            await axios.post('/api/category-products/' + data.slug + '?page=' + data.page, data).then((res) => {
                commit('setProducts', res.data.data)
                commit('setPagination', res.data.meta.pagination);
            }).catch((err) => {

            })
        },
    },

    namespaced: true,

    // plugins: [sharedMutations({ predicate: ['setUser'] })],

};